<arm-dialog (onCancel)="cancel()"
            (onSubmit)="submit()"
            [disabled]="!mapForm.form.valid || !data.selectedItem.elements || data.selectedItem.elements.length === 0"
            [title]="(data.isEditMode ? 'Edit' : 'Add') + ' RESOURCE GROUP'">

  <form #mapForm="ngForm" autocomplete="off" class="resource-groups-dialog">
    <mat-form-field class="fullWidth">
      <mat-label>Name</mat-label>
      <input matInput required [(ngModel)]="data.selectedItem.name" maxlength="255" name="name">
      <mat-error>
        Name is <strong>required</strong>
      </mat-error>
    </mat-form-field>
    <mat-form-field class="fullWidth">
      <mat-label>Type</mat-label>
      <mat-select required [(ngModel)]="data.selectedItem.type" name="type" [disabled]="data.isEditMode"
                  (selectionChange)="clearElements(); setGroupElements()">
        <mat-option *ngFor="let type of data.elementTypes" [value]="type.value">
          {{type.text}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <ac-input-container label="Elements" class="fullWidth" [required]="true" class="elements-select">
      <ac-select [acModel]="data.selectedItem.elements"
                 [searchable]="true"
                 [multiple]="true"
                 alternativeName="group.elements"
                 (acModelChange)="data.selectedItem.elements = $event"
                 [items]="elements"
                 [bindLabel]="'name'"
                 [bindValue]="'id'"
                 [groupBy]="'parentName'">
      </ac-select>
      <mat-error *ngIf="isElementSelected()">At least one element is <strong>required</strong></mat-error>
    </ac-input-container>

    <mat-form-field class="fullWidth" *ngIf="isPeerConnectionType()">
      <mat-label>Calls Quota</mat-label>
      <mat-select [(ngModel)]="data.selectedItem.callsQuotaId" name="callsQuota">
        <mat-option></mat-option>
        <mat-option *ngFor="let callsQuota of data.callsQuotas" [value]="callsQuota.id">
          {{callsQuota.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </form>
</arm-dialog>
